/**
 * Tracks how the user entered the standard intro → /interview flow so UI can vary
 * (e.g. resume/mock vs JD) without coupling to start payload shape.
 */
export const INTERVIEW_ENTRY_FLOW_KEY = 'interviewEntryFlow'

export type InterviewEntryFlow = 'resume' | 'jd'

export function setInterviewEntryFlow(flow: InterviewEntryFlow): void {
  if (typeof window === 'undefined') return
  try {
    sessionStorage.setItem(INTERVIEW_ENTRY_FLOW_KEY, flow)
  } catch {
    // ignore quota / private mode
  }
}

export function getInterviewEntryFlow(): InterviewEntryFlow | null {
  if (typeof window === 'undefined') return null
  try {
    const v = sessionStorage.getItem(INTERVIEW_ENTRY_FLOW_KEY)
    if (v === 'resume' || v === 'jd') return v
    return null
  } catch {
    return null
  }
}
